<template>
  <div>
    <section class="slide-section-main chat-wrapper chat-header" v-if="friends">
      <header-vue :group-username="groupUserName" />
      <section-vue
        :go-to-bottom-action="goToTheBottomAction"
        :update-go-to-bottom="updateGoToBottomAction"
      />
      <footer-vue
        :update-go-to-bottom="updateGoToBottomAction"
        :group-username="groupUserName"
      />
    </section>

    <!-- Loader -->
    <div class="loader-container" v-else>
      <loader-vue />
    </div>
  </div>
</template>

<script>
import HeaderVue from "./Header.vue";
import SectionVue from "./Section.vue";
import FooterVue from "./Footer.vue";
import LoaderVue from "../Appointment/common/Loader";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { permissionMixin } from "../../mixins/permissionMixin";
import { addNewChatAndCallMixin } from "../../mixins/addNewChatAndCallMixin";
import { authMixin } from "../../mixins/authMixin";

export default {
  mixins: [authMixin, addNewChatAndCallMixin, permissionMixin],
  data() {
    return {
      goToTheBottomAction: false
    };
  },
  components: {
    HeaderVue,
    SectionVue,
    FooterVue,
    LoaderVue
  },
  computed: {
    ...mapGetters("chat", {
      groupFriends: "getGroups",
      friends: "getFriends",
      getIsGroup: "getIsGroup"
    }),
    routeId() {
      return this.$route.params.id;
    },
    groupUserName() {
      // Step 1: Check if part of of exisiting group friends
      if (this.$route.params.id in this.groupFriends) {
        return this.groupFriends[this.$route.params.id].group_name;
      }

      // Step 2: When not a part of existing group friends
      if (this.getIsGroup && this.groups) {
        const group = this.groups.find(
          group => +group.id === +this.$route.params.id
        );
        if (group !== -1) {
          return group.name;
        }
      }
      return "";
    }
  },
  methods: {
    ...mapActions("chat", {
      getDetails: "getDetails",
      getMessages: "getMessages",
      getRemaingMessages: "getRemaingMessages"
    }),
    ...mapActions({
      getFormDetails: "getFormDetails"
    }),
    ...mapMutations("chat", {
      setSelectedUserId: "setSelectedUserId",
      setIsGroup: "setIsGroup"
    }),
    ...mapMutations({
      emptySearchAll: "emptySearchAll"
    }),
    updateGoToBottomAction(value) {
      this.goToTheBottomAction = value;
    }
  },
  async created() {
    // Step 1: Check if group route
    if (this.$route.path.includes("group")) {
      this.setIsGroup(true);
    } else {
      this.setIsGroup(false);
    }

    // Step 2: Fetch the messages
    if (this.$route.params.id === undefined) {
      await this.getDetails();
      if ((await this.getMessages()) === "NOT_LOADED") {
        this.$router.push("/chat_dashboard");
      } else {
        this.getRemaingMessages();
      }
    } else if (this.checkIfNotPortalUser) {
      // Step A: Get the details and form details
      await Promise.all([this.getDetails(), this.getFormDetails()]);

      // Step B: Check if id is a part of friends or group
      if (
        this.$route.params.id in this.friends ||
        this.groups.findIndex(group => +group.id === +this.$route.params.id) !==
          -1
      ) {
        this.setSelectedUserId(this.$route.params.id);
        this.getMessages();
        this.getRemaingMessages();
      } else {
        this.$router.push("/chat_dashboard");
      }
    } else {
      // Step A: Get the details and form details
      await Promise.all([this.getDetails()]);

      // Step B: Check if id is a part of friends or group
      if (
        this.$route.params.id in this.friends ||
        this.$route.params.id in this.groupFriends
      ) {
        this.setSelectedUserId(this.$route.params.id);
        this.getMessages();
        this.getRemaingMessages();
      } else {
        this.$router.push("/chat_dashboard");
      }
    }
  },
  watch: {
    routeId() {
      if (
        this.$route.params.id !== undefined &&
        this.$route.params.id in this.friends
      ) {
        this.setSelectedUserId(this.$route.params.id);
        this.getMessages();
        this.getRemaingMessages();
      } else {
        this.$router.push("/chat_dashboard");
      }
    }
  },
  destroyed() {
    this.emptySearchAll();
  }
};
</script>

<style scoped>
/* CSS HERE */
.slide-section-main {
  display: block;
  margin-top: 0px;
  padding-top: 0px;
  position: relative;
  background-color: #fff;
}

.slide-section-main header {
  top: 0px;
  min-height: 105px;
  background-color: #f1f0f6;
}

section {
  padding-bottom: 10vh !important;
}
</style>
